export const EXPORT_TEMPLATES = {
    TEMPLATE_ACTIONS_MENU: "template-actions-menu",
    TEMPLATE_ACTIONS_DELETE: "template-actions-delete",
    TEMPLATE_ACTION_SET_AS_DEFAULT: "template-actions-set-as-default",
    TEMPLATE_TOGGLE_ACTIVE: "template-toggle-active",
    LISTING_NAME: "listing-name",
    LISTING_LAST_MODIFIED: "listing-last-modified",
    LISTING_CREATED_ON: "listing-created-on",
    LISTING_STATUS: "listing-status",
    LISTING_DEFAULT_BADGE: "listing-default-badge",
    ADD_HEADER_ROW: "add-header-row",
    HEADER_ROW: "header-row",
    FIELD_OPTION_SELECT: "field-option-select",
    FIELD_OPTION_SELECT_OPTION: "field-option-select-option",
    FIELD_OPTION_BUTTON_DELETE: "field-option-button-delete",
    TEMPLATE_SELECT_INVENTORY_FORMAT: "template-select-inventory-format",
    TEMPLATE_SELECT_INVENTORY_FORMAT_OPTION: "template-select-inventory-format-option",
    TEMPLATE_SELECT_FILE_FORMAT: "template-select-file-format",
    TEMPLATE_SELECT_FILE_FORMAT_OPTION: "template-select-file-format-option",
    EXPORT_DOWNLOAD_LINK: "export-download-link",
    PRODUCT_GROUPING_TITLE: "product-grouping-title",
    PRODUCT_GROUPING_TYPE_SELECT: "product-grouping-type-select",
    ONE_TAB_OPTION: "all-in-one-tab",
    SPLIT_BY_OPTION: "split-by-attribute",
    GROUP_BY_OPTION: "group-by-attribute",
    PRODUCT_GROUPING_ATTRIBUTE_SELECT: "product-grouping-attribute-select",
    GROUPING_ATTRIBUTE_OPTION: "grouping-attribute",
    CREATE_TEMPLATE_BTN: "create-template-btn",
    SAVE_EXPORT_OPTIONS_BTN: "save-export-options-btn",

    IMPORT: {
        ROW: "export-format-row",
        DESCRIPTION: "export-format-description",
        HEADERS: "export-format-headers",
    },
};
